import { etiquetaEstado, etiquetaMotivo } from './formato'

/**
 * Las dos insignias de la pantalla. El color nunca lleva el dato solo: cada una
 * escribe la palabra, como ya hacen las de avisos y las de animo. Hay operadores
 * que no distinguen bien los colores, y aqui lo que se distingue es si un pedido
 * se ha creado o no.
 */

const CLASE = 'inline-flex rounded-full px-2 py-0.5 text-xs font-semibold ring-1'

const NEUTRO = 'bg-pendiente-fondo text-pendiente-tinta ring-pendiente-anillo'
const BIEN = 'bg-positivo-fondo text-positivo-tinta ring-positivo-anillo'
const ATENCION = 'bg-atencion-fondo text-atencion-tinta ring-atencion-anillo'
const MAL = 'bg-critico-fondo text-critico-tinta ring-critico-anillo'

/** Como se resolvio la ficha de Odoo. Solo `ambiguo` pide algo al administrador. */
const MOTIVOS: Record<string, string> = {
  resuelto_por_nif: BIEN,
  resuelto_por_nombre: BIEN,
  resuelto_por_antiguedad: BIEN,
  ambiguo: ATENCION,
  sin_ficha: MAL,
  sin_nif: MAL,
  sin_cliente: MAL,
}

export function InsigniaMotivo({ motivo }: { motivo: string }) {
  return <span className={`${CLASE} ${MOTIVOS[motivo] ?? NEUTRO}`}>{etiquetaMotivo(motivo)}</span>
}

/**
 * Como termino un cliente al publicar.
 *
 * `publicado_sin_evento` **no es un fallo** y no se pinta como tal: el
 * presupuesto esta creado y en el ciclo de reparto, y lo unico que falta es el
 * evento del calendario. Confundirlo con un error llevaria a alguien a volver a
 * crear el pedido a mano. Por eso va en ambar, junto al numero de presupuesto
 * que si existe, y no en rojo.
 */
const ESTADOS: Record<string, string> = {
  publicado: BIEN,
  publicado_sin_evento: ATENCION,
  duplicado: NEUTRO,
  ambiguo: ATENCION,
  fallido: MAL,
}

export function InsigniaEstadoPublicacion({ estado }: { estado: string }) {
  return <span className={`${CLASE} ${ESTADOS[estado] ?? NEUTRO}`}>{etiquetaEstado(estado)}</span>
}
